import { NgModule } from '@angular/core';
import { AuthRedirectService, GlobalMessageService } from '@spartacus/core';
import { CustomGlobalMessageService } from '@services/custom-global-message.service';
import { CustomLogoutGuard } from '@guards/custom-logout.guard';
import { LogoutGuard } from '@spartacus/storefront';
import { CustomAuthRedirectService } from '@guards/custom-auth-redirect.service';



@NgModule({
  declarations: [],
  imports: [],
  providers: [
    {provide: GlobalMessageService, useClass: CustomGlobalMessageService},
    {provide: LogoutGuard, useClass: CustomLogoutGuard},
    {provide: AuthRedirectService, useClass: CustomAuthRedirectService}
  ]
})
export class CustomGuardsModule { }
